import { render } from "./UserRecursiveComment.vue?vue&type=template&id=785e8764&scoped=true"
import script from "./UserRecursiveComment.vue?vue&type=script&lang=js"
export * from "./UserRecursiveComment.vue?vue&type=script&lang=js"

import "./UserRecursiveComment.vue?vue&type=style&index=0&id=785e8764&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785e8764"]])

export default __exports__